<router-outlet></router-outlet>
<app-toast />

@if (authService.enabledLoaderAuth) {
  <app-loader/>
}
